import {useDispatch} from 'react-redux'
import {useState} from 'react'
import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js'
import {envAwarePost} from '../../../util/util'
import {setCurrentUser} from '../../users/usersSlice'
import {
	setShowUpdateModal,
	setShowResetCurrencyModal
} from './slice'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {successStatus} from '../../../state/apiStatusSlice'

const getSetupIntent = (create_new_account) => envAwarePost(
	'api/user/api/',
	{
		action:'getSetupIntent',
		create_new_account
	}
)

const makePaymentMethodDefault = (payment_method_id) => envAwarePost(
	'api/user/api/',
	{
		action:'makePaymentMethodDefault',
		payment_method_id
	}
)

const BillingUpdateForm = ({create_new_account})=>{
	const stripe = useStripe()
	const elements = useElements()
	const dispatch = useDispatch()
	const [status,setStatus] = useState('idle')

	const confirmSetup = () => (
		stripe.confirmSetup({
			elements,
			confirmParams: {
				return_url: 'https://www.fitsw.com',
			},
			redirect:'if_required'
		})
	)
	const handleUpdate = async (event)=>{
		setStatus('pending')
		// Block native form submission.
		event.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not loaded yet. Make sure to disable
			// form submission until Stripe.js has loaded.
			return;
		}

		confirmSetup().then(res=>{
			if (res.error) throw new Error(res.error.message)
			if (res.setupIntent.status !== 'succeeded') {
				throw new Error("Something went wrong. Please, try again")
			}
			return makePaymentMethodDefault(res.setupIntent.payment_method)
		}).then(res=>{
			if(res.success==='1'){
				dispatch(setCurrentUser(res.data.user))
			}
		}).then( res => {
			setStatus('idle')
			dispatch(setShowUpdateModal(false))
			dispatch(setShowResetCurrencyModal(false))
			dispatch(successStatus({item:'billing info', operation:'edit', success:true})) 
		}).catch( err => {
			setStatus('idle')
			window.alert(err)
			dispatch(successStatus({item:'billing info', operation:'edit', success:false})) 
		})
	}
	return (
		<div>
			<PaymentElement /> 
			<Button 
				disabled={status==='pending'}
				variant="outline-primary" 
				onClick={handleUpdate}
				className="mt-2" 
				block
			>
				<span className="mr-1">Update</span>
				{status==='pending'&&<Spinner animation="border" size="sm" />}
			</Button>
		</div>
	)
}

export default BillingUpdateForm